export default __webpack_public_path__ + "static/media/left-arrow.f6c6322c.svg";